import { addToCart, pushToGTMDataLayer } from '@nova/utils'

document.addEventListener('DOMContentLoaded', () => {
  const $sizeGuideBtns =
    document.querySelectorAll('.js-size-guide-button') || []
  const $sizeGuideDrawer = document.querySelector('.js-size-guide-drawer') || []

  function handleATCClass(atcBtn, scrollThreshold) {
    const $qtyAtcWrapper = document.querySelector('.product__qty_atc--wrapper')
    const fixedButtonClass = 'addtocart-fixed-mobile'
    const currentScrollPosition =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0
    const shouldShowFixedButton =
      (currentScrollPosition < scrollThreshold || atcBtn.offsetTop < currentScrollPosition) &&
      $qtyAtcWrapper
    atcBtn.classList.toggle(fixedButtonClass, shouldShowFixedButton)
  }

  function fixedAddCart() {
    const $addToCartBtn = document.querySelector('[data-scroll-fixed]')
    if ($addToCartBtn) {
      const scrollThreshold = $addToCartBtn.offsetTop - window.innerHeight - 40
      handleATCClass($addToCartBtn, scrollThreshold)
      window.addEventListener('scroll', () =>
        handleATCClass($addToCartBtn, scrollThreshold),
      )
    }
  }
  fixedAddCart()

  function appliedFormAction() {
    const $forms = Array.from(document.querySelectorAll('.js-product-form') || [])
    if ($forms.length) {
      for (const $form of $forms) {
        const $submitButton = $form.querySelector('[type="submit"]')
        const $quantityInput = document.querySelector(
          `nova-quantity-input[data-form-id=${$form.getAttribute('id')}]`,
        )
        $form.addEventListener('submit', (event) => {
          event.preventDefault()

          $submitButton.setAttribute('disabled', true)
          $submitButton.classList.add('loading')

          const formData = new FormData($form)
          const id = formData.get('id')
          const quantity = $quantityInput.value
          const entries = Object.fromEntries(formData.entries());

          addToCart({ id, quantity }).then(() => {
            $submitButton.removeAttribute('disabled')
            $submitButton.classList.remove('loading')
          })
        })
      }
    }
    fixedAddCart()
  }
  appliedFormAction()

  document.addEventListener('nova:product:render-form', (event) => {
    const content = event.detail.html
    if (!content) return
    const isAvailable = content.dataset.available === 'true'
    const $formContainer = document.querySelector('.js-product-form')
    const $bisContainer = document.querySelector('.js-product-bis')

    const $bisId = $bisContainer.querySelector('[name="id"]')
    const $productId = $formContainer.querySelector('[name="id"]')
    const $productPrice = $formContainer.querySelector('[name="price"]')
    const $productName = $formContainer.querySelector('[name="name"]')
    const $productCategory = $formContainer.querySelector('[name="category"]')
    const $productBrand = $formContainer.querySelector('[name="brand"]')
    const $formBtn = $formContainer.querySelector('.js-product-buy-button')

    const $contentProductId = content.querySelector('[name="id"]')
    const $contentProductPrice = content.querySelector('[name="price"]')
    const $contentProductName = content.querySelector('[name="name"]')
    const $contentProductCategory = content.querySelector('[name="category"]')
    const $contentProductBrand = content.querySelector('[name="brand"]')
    const $contentFormBtn = content.querySelector('.js-product-buy-button')

    $bisId.value = $contentProductId.value
    $productId.value = $contentProductId.value
    $productPrice.value = $contentProductPrice.value
    $productName.value = $contentProductName.value
    $productCategory.value = $contentProductCategory.value
    $productBrand.value = $contentProductBrand.value

    $formBtn.innerHTML = $contentFormBtn.innerHTML
    if($contentFormBtn.disabled) {
      $formBtn.setAttribute('disabled', true)
    } else {
      $formBtn.removeAttribute('disabled')
    }

    if (isAvailable) {
      document.querySelector('.js-product-bis').classList.add('hidden')
      document.querySelector('.js-product-qty-atc-wrapper').classList.remove('hidden')
      document.querySelector('.js-product-installment').classList.remove('hidden')
    } else {
      document.querySelector('.js-product-bis').classList.remove('hidden')
      document.querySelector('.js-product-qty-atc-wrapper').classList.add('hidden')
      document.querySelector('.js-product-installment').classList.add('hidden')
    }
  })

  document.addEventListener('nova:product:render-form-installment', (event) => {
    const content = event.detail.html
    if (!content) return
    const $formInstallment = document.querySelector('.js-product-installment')
    $formInstallment.innerHTML = content.innerHTML
  })

  document.addEventListener('nova:product:render-details-collapsible', (event) => {
    const content = event.detail.html
    if (!content) return
    const $detailsElement = document.querySelector('.js-details-collapsible-tab')
    const $elementStatus = $detailsElement.querySelector('sl-details')?.hasAttribute('open') === true

    $detailsElement.innerHTML = content.innerHTML

    if ($elementStatus) {
      $detailsElement.querySelector('sl-details')?.setAttribute('open', true)
    }
  })


  document.addEventListener('nova:product:render-product-pickup', (event) => {
    const content = event.detail.html
    if (!content) return
    const $productPickup = document.querySelector('.js-product-pickup')
    $productPickup.innerHTML = content.innerHTML
  })

  if ($sizeGuideDrawer) {
    for (const $button of $sizeGuideBtns) {
      $button.addEventListener('click', () => {
        if ($sizeGuideDrawer.hasAttribute('open')) {
          $sizeGuideDrawer.hide()
        } else {
          $sizeGuideDrawer.show()
        }
      })
    }
  }

  function addShopPayStyle() {
    const shadowHost = document.querySelector('shopify-payment-terms');
    if (!shadowHost || !shadowHost.shadowRoot) return;
    const style = document.createElement('style');
    style.textContent = `
      .font-system {
        font-family: "HelveticaNeueETPro-55-Regular", sans-serif !important;
        font-weight: 400 !important;
      }

      .font-bold {
        font-family: "HelveticaNeueETPro-75-Bold", sans-serif !important;
        font-weight: 700 !important;
      }

      #shopify-installments-content svg {
        aspect-ratio: 59 / 14 !important;
        height: 16px !important;
        width: auto !important;
      }
    `;

    shadowHost.shadowRoot.appendChild(style);


    const observer = new MutationObserver((mutations, obs) => {
      const portalProvider = document.querySelector('[data-nametag="shop-portal-provider"]');
      if (portalProvider) {
        if (!portalProvider.shadowRoot) return;
        const style = document.createElement('style');
        style.textContent = `
          .text-body-large,
          [data-testid="split-pay-subtitle"] {
            font: var(--nova-h6-font) !important;
            letter-spacing: var(--nova-h6-letter-spacing) !important;
            color: var(--nova-color-brand-charcoal) !important;
          }

          [data-testid="split-pay-content"] span {
            font: var(--nova-body-font) !important;
            letter-spacing: var(--nova-body-letter-spacing) !important;
            color: var(--nova-color-brand-charcoal) !important;
          }

          #eligibility-approval,
          small {
            font: var(--nova-body-caption) !important;
            color: var(--nova-color-brand-charcoal) !important;
          }
        `;

        portalProvider.shadowRoot.appendChild(style);

        obs.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }
  addShopPayStyle()

  if (window.gtmViewItemData) {
    // GTM Event: view_item
    pushToGTMDataLayer('view_item', window.gtmViewItemData);
  }

  function updateGalleryThumbnails() {
    // Update gallery thumbnails role to be buttons for better accessibility
    const $galleryThumbnails = document.querySelectorAll('.js-pdp-thumbnails-item')
    if ($galleryThumbnails.length && $galleryThumbnails.length > 0) {
      for (const $thumbnail of $galleryThumbnails) {
        $thumbnail.setAttribute('role', 'button')
      }
    }
  }
  requestAnimationFrame(() => {
    updateGalleryThumbnails();
  });
})
